module.exports = __webpack_public_path__ + "img/QA_pin.da38a7ca.svg";